import { render, staticRenderFns } from "./oldEdit.vue?vue&type=template&id=787509c8&scoped=true&"
import script from "./oldEdit.vue?vue&type=script&lang=js&"
export * from "./oldEdit.vue?vue&type=script&lang=js&"
import style0 from "./oldEdit.vue?vue&type=style&index=0&id=787509c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787509c8",
  null
  
)

export default component.exports